
export default function titleFormColumns () {

	const section = document.querySelector('section.title-form-2-columns');

	if (! section) return;



	// Check if "message" parameter exists and has a value
	const urlParams = new URLSearchParams(window.location.search);

	if (urlParams.has('message') && urlParams.get('message').trim() !== '') {
		section.scrollIntoView({
			block: 'start',
			behavior: 'smooth',
		});
	}

}
